<template>
  <div
    id="jMenuProducts"
    class="menu-product">
    <div
      v-for="product in products"
      v-show="product.isShow"
      :key="product.name"
      class="product">
      <div>
        <router-link
          v-if="product.href"
          :to="product.href"
          tag="a"
          exact-path
          class="menu-product__lists product product-icon">
          <div class="image">
            <img :src="product.img">
          </div>
          <div class="product-label">
            <p>
              {{ product.name }}
            </p>
          </div>
        </router-link>
        <div v-else-if="product.hrefout">
          <a
            :href="product.hrefout"
            class="menu-product__lists product product-icon">
            <div class="image">
              <img :src="product.img">
            </div>
            <div class="product-label">
              <p>
                {{ product.name }}
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
/* eslint linebreak-style: ["error", "windows"] */
export default {
/**
 * Created by Arga Ghulam Ahmad - arga@jojonomic.com
 * Last update 6 august 2018
 *
 * Menu Products component.
 * Container for all jojonomic products.
 */
  name: 'JMenuProducts',
  props: {
    products: Array,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sidebar/jMenuProducts.vue